// THE DEFAULT VIEW — three columns side by side on a wide screen, stacked on a narrow one:
// what is late, what is ours to do, what is owed and not yet due.
//
// EACH COLUMN STATES ITS OWN FIGURE, ONCE, in its head: the late column the server's late
// amount (`totals.overdue`), the other two how many rows they hold. A figure the server did
// not send is shown as "—", never as 0 — a stale server must not read as "nothing late".
//
// Every column is always drawn, empty or not, and says which kind of nothing it holds: a
// column that hid itself could not be told apart from one that failed to load.
import he from '../../i18n/he';
import Money from '../../components/Money';
import { SECTIONS } from './actionRows';
import ActionItem from './ActionItem';

const s = he.moneyScreen.sections;

// A tick, a cleared tray, a clock — the only thing an empty column says besides its words.
const EMPTY_MARK = {
  late: ['M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z', 'm8.5 12 2.5 2.5 4.5-5'],
  todo: ['M4 13h4l1.5 2.5h5L16 13h4', 'M4 13l2.5-7h11L20 13v5H4z'],
  owed: ['M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z', 'M12 7.5V12l3 2'],
};

function Empty({ kind }) {
  return (
    <div className="mp-empty">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        {EMPTY_MARK[kind].map((d) => <path key={d} d={d} />)}
      </svg>
      {s[kind].empty}
    </div>
  );
}

function HeadFigure({ kind, rows, totals }) {
  if (kind !== 'late') return <span className="mp-head-count">{rows.length}</span>;
  return totals.overdue != null
    ? <Money className="mp-head-amount" value={totals.overdue} />
    : <span className="mp-head-amount">—</span>;
}

export default function ActionList({ actions, totals, acts }) {
  return (
    <div className="mp-sections">
      {SECTIONS.map((key) => (
        <section key={key} className={`mp-section mp-tone-${key}`}>
          <header className="mp-section-head">
            <span className="mp-dot" aria-hidden />
            <h2>{s[key].title}</h2>
            <HeadFigure kind={key} rows={actions[key]} totals={totals} />
          </header>
          {actions[key].length > 0
            ? actions[key].map((item) => <ActionItem key={item.key} item={item} acts={acts} />)
            : <Empty kind={key} />}
        </section>
      ))}
    </div>
  );
}
